// extracted by mini-css-extract-plugin
module.exports = {"card-widget":"parts-item_card-widget__UKohX"};